"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

require("core-js/modules/es.function.name");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.registerDateInputElement = exports.renderDateInputItem = exports.BmDateInputField = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/taggedTemplateLiteral"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createSuper"));

var _element = require("@blue/element");

var _uiElements = require("@blue/ui-elements");

var _inputFieldRenderer = require("../../../../core/render/items/input-engine/input-field-renderer");

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)([" <bm-date-input-field .info=\"", "\"></bm-date-input-field> "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t\t\t<bm-date large updated-style\n\t\t\t\t.name=\"", "\"\n\t\t\t\tvalue=", "\n\t\t\t\tmin=\"", "\"\n\t\t\t\tmax=\"", "\"\n\t\t\t\trange=\"", "\"\n\t\t\t\tlocale=\"", "\"\n\t\t\t\t.disabled=", "\n\t\t\t\t.readonly=", "\n\t\t\t\t?showSeparators=\"", "\"\n\t\t\t\t?required=", "\n\t\t\t\tdata-qe-id=\"", "\"\n\t\t\t\t@change=", "\n\t\t\t\t@blur=", "\n\t\t\t\t></bm-date>\n\t\t"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var BmDateInputField = /*#__PURE__*/function (_BmInputFieldElement) {
  (0, _inherits2.default)(BmDateInputField, _BmInputFieldElement);

  var _super = (0, _createSuper2.default)(BmDateInputField);

  function BmDateInputField() {
    (0, _classCallCheck2.default)(this, BmDateInputField);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(BmDateInputField, [{
    key: "_renderInput",
    value: function _renderInput() {
      return this.html(_templateObject(), this.info.name, this.info.value || '', (0, _element.ifDefined)(this.info.options.min), (0, _element.ifDefined)(this.info.options.max), (0, _element.ifDefined)(this.info.options.range), (0, _element.ifDefined)(this.info.options.locale), Boolean(this.disabled), Boolean(this.readonly), this.readonly, this.required, (0, _element.ifDefined)(this.info.options.dataQeId), this.handleFormEvent, this.handleFormEvent);
    }
  }, {
    key: "handleFormEvent",
    value: function handleFormEvent(evt) {
      if (evt.type === 'blur') {
        if (!this.info.touched) {
          this.dispatchBmFormEvent({
            type: 'touched'
          });
        }
      } else if (evt.type === 'change') {
        this.dispatchBmFormEvent({
          type: 'changed',
          data: {
            currentValue: evt.detail.value,
            previousValue: this.value
          }
        });
      }
    }
  }], [{
    key: "is",
    get: function get() {
      return 'bm-date-input-field';
    }
  }, {
    key: "properties",
    get: function get() {
      return {
        info: {
          type: Object,
          attribute: false,
          reflect: false
        }
      };
    }
  }]);
  return BmDateInputField;
}(_inputFieldRenderer.BmInputFieldElement);

exports.BmDateInputField = BmDateInputField;

var renderDateInputItem = function renderDateInputItem(info) {
  return (0, _element.html)(_templateObject2(), info);
};

exports.renderDateInputItem = renderDateInputItem;

var registerDateInputElement = function registerDateInputElement() {
  (0, _uiElements.registerDate)();
  (0, _element.register)(BmDateInputField);
};

exports.registerDateInputElement = registerDateInputElement;
